import { Operation } from '../../../__generated__/globalTypes'

import {
  CampaignFragment,
  campaignFragmentString,
} from '../../fragments/__generated__/CampaignFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { campaignLineFragmentString } from '../../fragments/__generated__/CampaignLineFragment'

import { minimalPanelFragmentString } from '../../fragments/__generated__/MinimalPanelFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import getCampaignRawString from '../GetCampaign.graphql'

const getCampaignString = [
  getCampaignRawString,
  campaignFragmentString,
  sendDelayFragmentString,
  campaignLineFragmentString,
  minimalPanelFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type GetCampaignData = {
  campaign: CampaignFragment
}

export type GetCampaignVariables = {
  id: string
}

export type GetCampaign = Operation<GetCampaignData, GetCampaignVariables>

export const GetCampaign = ({ id }: GetCampaignVariables): GetCampaign => ({
  query: getCampaignString,
  variables: {
    id,
  },
})
